import { GaTrackingEventLabel } from '~shared/modules/ga-tracking/constants';
import {
  FOR_BUYERS_COLUMN,
  METRO_MARKETS_COLUMN,
  FOR_SELLERS_COLUMN,
  EXTERNAL_DOMAIN_TYPE,
  BUYER_DOMAIN_TYPE,
  SELLER_DOMAIN_TYPE,
  SupportPhoneNumbers,
  FOOTER_IMAGES,
  FOOTER_NAVIGATION_LINKS,
  FOOTER_LABELS,
} from '~app/modules/generic/constants';
import {
  BUYER_FAQ_EXTERNAL_LINK,
  BUYER_SUPPORT_TICKET_NEW_LINK,
  DE_BUYER_OFFERS_EXTERNAL_LINK,
  DE_BUYER_SUPPORT_EXTERNAL_LINK,
  ES_BUYER_FAQ_EXTERNAL_LINK,
  ES_BUYER_SUPPORT_EXTERNAL_LINK,
  ES_BUYER_SUPPORT_TICKET_NEW_LINK,
  ES_ORDER_INFO_LINK,
  ES_RETURN_INFO_LINK,
  ES_SELLER_SUPPORT_HOME_LINK,
  ES_SHIPPING_INFO_LINK,
  LEGAL_ABOUT_LINK,
  ORDER_INFO_LINK,
  RETURN_INFO_LINK,
  SELLER_OFFICE_EXTERNAL_LINK,
  SELLER_SUPPORT_HOME_LINK,
  SHIPPING_INFO_LINK,
  MM_CAREERS_LINK,
  IT_BUYER_FAQ_EXTERNAL_LINK,
  IT_BUYER_SUPPORT_EXTERNAL_LINK,
  IT_BUYER_SUPPORT_TICKET_NEW_LINK,
  IT_ORDER_INFO_LINK,
  IT_RETURN_INFO_LINK,
  IT_SELLER_SUPPORT_HOME_LINK,
  IT_SHIPPING_INFO_LINK,
  PT_ORDER_INFO_LINK,
  PT_SHIPPING_INFO_LINK,
  PT_RETURN_INFO_LINK,
  PT_BUYER_SUPPORT_EXTERNAL_LINK,
  PT_BUYER_FAQ_EXTERNAL_LINK,
  PT_BUYER_SUPPORT_TICKET_NEW_LINK,
  PT_SELLER_SUPPORT_HOME_LINK,
  PT_SELLER_SUPPORT_CONTACT_FORM_LINK,
  NL_ORDER_INFO_LINK,
  NL_SHIPPING_INFO_LINK,
  NL_RETURN_INFO_LINK,
  NL_BUYER_SUPPORT_EXTERNAL_LINK,
  NL_BUYER_FAQ_EXTERNAL_LINK,
  NL_BUYER_SUPPORT_TICKET_NEW_LINK,
  NL_SELLER_HELP_CENTER,
  NL_SELLER_START_SELLING,
  PT_BUYER_COMPLAINT_BOOK_EXTERNAL_LINK,
  FR_ORDER_INFO_LINK,
  FR_SHIPPING_INFO_LINK,
  FR_RETURN_INFO_LINK,
  FR_BUYER_SUPPORT_EXTERNAL_LINK,
  FR_BUYER_FAQ_EXTERNAL_LINK,
  FR_SELLER_START_SELLING,
  FR_SELLER_HELP_CENTER,
  FR_BUYER_SUPPORT_TICKET_NEW_LINK,
  SUBSIDIARY_SUPPORT_EMAIL,
  FRESHDESK_INSTANCE_LINK,
  SUBSIDIARY_SUPPORT_EMAIL_NL,
} from '~shared/constants/links.constants';
import { CountryCode } from '~shared/constants/country-code.enum';
import { TooltipPositions } from '~shared/modules/tooltip/tooltip.module';

const shippingInfoTooltip = 'FOOTER.ALL_PAGES.NAVIGATION.BUYER.SHIPPING_INFO.TOOLTIP';

const COMMON_NAVIGATION_LINKS = [
  {
    title: FOOTER_LABELS.AboutUs,
    domain: BUYER_DOMAIN_TYPE,
    externalLink: null,
    linkType: METRO_MARKETS_COLUMN,
    path: LEGAL_ABOUT_LINK,
    tooltip: null,
    tooltipPosition: null,
    trackingLabel: GaTrackingEventLabel.AboutUs,
  },
  {
    title: FOOTER_LABELS.Careers,
    domain: EXTERNAL_DOMAIN_TYPE,
    externalLink: MM_CAREERS_LINK,
    linkType: METRO_MARKETS_COLUMN,
    path: null,
    tooltip: null,
    tooltipPosition: null,
    trackingLabel: GaTrackingEventLabel.Careers,
  },
];

export const CALLBACK_CALENDLY_URLS = {
  [CountryCode.Germany]:
    'https://calendly.com/d/cph8-hsf-ppw/15-minuten-beratungsgesprach',
  [CountryCode.Spain]:
    'https://calendly.com/d/cmc3-bvm-3rp/15-mins-asesoramiento-personal-makro-es',
  [CountryCode.Italy]:
    'https://calendly.com/d/cpj8-c5r-nvq/15-minuti-consulenza-personale-metro-it',
  [CountryCode.Portugal]:
    'https://calendly.com/d/cnnr-gy9-6sb/15-minutos-de-consultoria-pessoal',
  [CountryCode.Netherlands]:
    'https://calendly.com/d/cq7m-pqg-7mq/15-minuten-adviesgesprek',
  [CountryCode.France]:
    'https://calendly.com/d/cpj5-2fm-664/entretien-commercial-de-15-minutes'
} as const

export const LOCAL_FOOTER_NAVIGATION_LINKS = {
  [CountryCode.Germany]: {
    [FOOTER_NAVIGATION_LINKS]: [
      {
        title: FOOTER_LABELS.Market,
        links: COMMON_NAVIGATION_LINKS,
        hideOnMMCompanion: true,
      },
      {
        title: FOOTER_LABELS.Buyers,
        links: [
          {
            title: FOOTER_LABELS.OrderInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: ORDER_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.OrderInfo,
          },
          {
            title: FOOTER_LABELS.ShippingInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: SHIPPING_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: shippingInfoTooltip,
            tooltipPosition: TooltipPositions.left,
            trackingLabel: GaTrackingEventLabel.ShippingInfo,
          },
          {
            title: FOOTER_LABELS.ReturnPolicy,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: RETURN_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.BuyerReturnPolicy,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: DE_BUYER_SUPPORT_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactBuyer,
          },
          {
            title: FOOTER_LABELS.FAQ,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: BUYER_FAQ_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.FAQ,
          },
          {
            title: FOOTER_LABELS.Offers,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: DE_BUYER_OFFERS_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.Offers,
          },
        ],
      },
      {
        title: FOOTER_LABELS.Sellers,
        links: [
          {
            title: FOOTER_LABELS.StartSelling,
            domain: SELLER_DOMAIN_TYPE,
            externalLink: SELLER_OFFICE_EXTERNAL_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.SellerStartSelling,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: SELLER_SUPPORT_HOME_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
        ],
        hideOnMMCompanion: true,
      },
    ],
    footer_for_payments: FOOTER_IMAGES[CountryCode.Germany],
    support_phone_number: SupportPhoneNumbers[CountryCode.Germany].b2c,
    support_phone_number_b2b: SupportPhoneNumbers[CountryCode.Germany].b2b,
    support_phone_number_subsidiary: SupportPhoneNumbers[CountryCode.Germany].subsidiary,
    telesales_phone_number: SupportPhoneNumbers[CountryCode.Germany].telesales,
    help_center_link: BUYER_SUPPORT_TICKET_NEW_LINK,
    subsidiary_contact_email: SUBSIDIARY_SUPPORT_EMAIL,
    freshdesk_instance_link: FRESHDESK_INSTANCE_LINK['de'],
  },
  [CountryCode.Spain]: {
    [FOOTER_NAVIGATION_LINKS]: [
      {
        title: FOOTER_LABELS.Market,
        links: COMMON_NAVIGATION_LINKS,
        hideOnMMCompanion: true,
      },
      {
        title: FOOTER_LABELS.Buyers,
        links: [
          {
            title: FOOTER_LABELS.OrderInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: ES_ORDER_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.OrderInfo,
          },
          {
            title: FOOTER_LABELS.ShippingInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: ES_SHIPPING_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: shippingInfoTooltip,
            tooltipPosition: TooltipPositions.left,
            trackingLabel: GaTrackingEventLabel.ShippingInfo,
          },
          {
            title: FOOTER_LABELS.ReturnPolicy,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: ES_RETURN_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.BuyerReturnPolicy,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: ES_BUYER_SUPPORT_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactBuyer,
          },
          {
            title: FOOTER_LABELS.FAQ,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: ES_BUYER_FAQ_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.FAQ,
          },
        ],
      },
      {
        title: FOOTER_LABELS.Sellers,
        links: [
          {
            title: FOOTER_LABELS.StartSelling,
            domain: SELLER_DOMAIN_TYPE,
            externalLink: SELLER_OFFICE_EXTERNAL_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.SellerMakroStartSelling,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: ES_SELLER_SUPPORT_HOME_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
        ],
        hideOnMMCompanion: true,
      },
    ],
    footer_for_payments: FOOTER_IMAGES[CountryCode.Spain],
    support_phone_number: SupportPhoneNumbers[CountryCode.Spain].b2c,
    support_phone_number_b2b: SupportPhoneNumbers[CountryCode.Spain].b2b,
    support_phone_number_subsidiary: SupportPhoneNumbers[CountryCode.Spain].subsidiary,
    telesales_phone_number: SupportPhoneNumbers[CountryCode.Spain].telesales,
    help_center_link: ES_BUYER_SUPPORT_TICKET_NEW_LINK,
    subsidiary_contact_email: SUBSIDIARY_SUPPORT_EMAIL,
    freshdesk_instance_link: FRESHDESK_INSTANCE_LINK['es'],
  },
  [CountryCode.Italy]: {
    [FOOTER_NAVIGATION_LINKS]: [
      {
        title: FOOTER_LABELS.Market,
        links: COMMON_NAVIGATION_LINKS,
        hideOnMMCompanion: true,
      },
      {
        title: FOOTER_LABELS.Buyers,
        links: [
          {
            title: FOOTER_LABELS.OrderInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: IT_ORDER_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.OrderInfo,
          },
          {
            title: FOOTER_LABELS.ShippingInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: IT_SHIPPING_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: shippingInfoTooltip,
            tooltipPosition: TooltipPositions.left,
            trackingLabel: GaTrackingEventLabel.ShippingInfo,
          },
          {
            title: FOOTER_LABELS.ReturnPolicy,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: IT_RETURN_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.BuyerReturnPolicy,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: IT_BUYER_SUPPORT_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactBuyer,
          },
          {
            title: FOOTER_LABELS.FAQ,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: IT_BUYER_FAQ_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.FAQ,
          },
        ],
      },
      {
        title: FOOTER_LABELS.Sellers,
        links: [
          {
            title: FOOTER_LABELS.StartSelling,
            domain: SELLER_DOMAIN_TYPE,
            externalLink: SELLER_OFFICE_EXTERNAL_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.SellerMetroITStartSelling,
          },
          {
            title: FOOTER_LABELS.SellerHelpCenter,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: IT_SELLER_SUPPORT_HOME_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
        ],
        hideOnMMCompanion: true,
      },
    ],
    footer_for_payments: FOOTER_IMAGES[CountryCode.Italy],
    support_phone_number: SupportPhoneNumbers[CountryCode.Italy].b2c,
    support_phone_number_b2b: SupportPhoneNumbers[CountryCode.Italy].b2b,
    support_phone_number_subsidiary: SupportPhoneNumbers[CountryCode.Italy].subsidiary,
    telesales_phone_number: SupportPhoneNumbers[CountryCode.Italy].telesales,
    help_center_link: IT_BUYER_SUPPORT_TICKET_NEW_LINK,
    subsidiary_contact_email: SUBSIDIARY_SUPPORT_EMAIL,
    freshdesk_instance_link: FRESHDESK_INSTANCE_LINK['it'],
  },
  [CountryCode.Portugal]: {
    [FOOTER_NAVIGATION_LINKS]: [
      {
        title: FOOTER_LABELS.Market,
        links: COMMON_NAVIGATION_LINKS,
        hideOnMMCompanion: true,
      },
      {
        title: FOOTER_LABELS.Buyers,
        links: [
          {
            title: FOOTER_LABELS.OrderInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: PT_ORDER_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.OrderInfo,
          },
          {
            title: FOOTER_LABELS.ShippingInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: PT_SHIPPING_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: shippingInfoTooltip,
            tooltipPosition: TooltipPositions.left,
            trackingLabel: GaTrackingEventLabel.ShippingInfo,
          },
          {
            title: FOOTER_LABELS.ReturnPolicy,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: PT_RETURN_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.BuyerReturnPolicy,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: PT_BUYER_SUPPORT_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactBuyer,
          },
          {
            title: FOOTER_LABELS.FAQ,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: PT_BUYER_FAQ_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.FAQ,
          },
          {
            title: FOOTER_LABELS.ComplaintBook,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: PT_BUYER_COMPLAINT_BOOK_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ComplaintBook,
          },
        ],
      },
      {
        title: FOOTER_LABELS.Sellers,
        links: [
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: PT_SELLER_SUPPORT_HOME_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
          {
            title: FOOTER_LABELS.SellerHelpCenter,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: PT_SELLER_SUPPORT_CONTACT_FORM_LINK,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
        ],
        hideOnMMCompanion: true,
      },
    ],
    footer_for_payments: FOOTER_IMAGES[CountryCode.Portugal],
    support_phone_number: SupportPhoneNumbers[CountryCode.Portugal].b2c,
    support_phone_number_b2b: SupportPhoneNumbers[CountryCode.Portugal].b2b,
    support_phone_disclaimer: SupportPhoneNumbers[CountryCode.Portugal].disclaimer,
    support_phone_number_subsidiary: SupportPhoneNumbers[CountryCode.Portugal].subsidiary,
    telesales_phone_number: SupportPhoneNumbers[CountryCode.Portugal].telesales,
    help_center_link: PT_BUYER_SUPPORT_TICKET_NEW_LINK,
    subsidiary_contact_email: SUBSIDIARY_SUPPORT_EMAIL,
    freshdesk_instance_link: FRESHDESK_INSTANCE_LINK['pt'],
  },
  [CountryCode.Netherlands]: {
    [FOOTER_NAVIGATION_LINKS]: [
      {
        title: FOOTER_LABELS.Market,
        links: COMMON_NAVIGATION_LINKS,
        hideOnMMCompanion: true,
      },
      {
        title: FOOTER_LABELS.Buyers,
        links: [
          {
            title: FOOTER_LABELS.OrderInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: NL_ORDER_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.OrderInfo,
          },
          {
            title: FOOTER_LABELS.ShippingInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: NL_SHIPPING_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: shippingInfoTooltip,
            tooltipPosition: TooltipPositions.left,
            trackingLabel: GaTrackingEventLabel.ShippingInfo,
          },
          {
            title: FOOTER_LABELS.ReturnPolicy,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: NL_RETURN_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.BuyerReturnPolicy,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: NL_BUYER_SUPPORT_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactBuyer,
          },
          {
            title: FOOTER_LABELS.FAQ,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: NL_BUYER_FAQ_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.FAQ,
          },
        ],
      },
      {
        title: FOOTER_LABELS.Sellers,
        links: [
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: NL_SELLER_HELP_CENTER,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
          {
            title: FOOTER_LABELS.StartSelling,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: NL_SELLER_START_SELLING,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
        ],
        hideOnMMCompanion: true,
      },
    ],
    footer_for_payments: FOOTER_IMAGES[CountryCode.Netherlands],
    support_phone_number: SupportPhoneNumbers[CountryCode.Netherlands].b2c,
    support_phone_number_b2b: SupportPhoneNumbers[CountryCode.Netherlands].b2b,
    support_phone_number_subsidiary: SupportPhoneNumbers[CountryCode.Netherlands].subsidiary,
    telesales_phone_number: SupportPhoneNumbers[CountryCode.Netherlands].telesales,
    help_center_link: NL_BUYER_SUPPORT_TICKET_NEW_LINK,
    subsidiary_contact_email: SUBSIDIARY_SUPPORT_EMAIL_NL,
    freshdesk_instance_link: FRESHDESK_INSTANCE_LINK['nl'],
  },
  [CountryCode.France]: {
    [FOOTER_NAVIGATION_LINKS]: [
      {
        title: FOOTER_LABELS.Market,
        links: COMMON_NAVIGATION_LINKS,
        hideOnMMCompanion: true,
      },
      {
        title: FOOTER_LABELS.Buyers,
        links: [
          {
            title: FOOTER_LABELS.OrderInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: FR_ORDER_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.OrderInfo,
          },
          {
            title: FOOTER_LABELS.ShippingInfo,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: FR_SHIPPING_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: shippingInfoTooltip,
            tooltipPosition: TooltipPositions.left,
            trackingLabel: GaTrackingEventLabel.ShippingInfo,
          },
          {
            title: FOOTER_LABELS.ReturnPolicy,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: FR_RETURN_INFO_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.BuyerReturnPolicy,
          },
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: FR_BUYER_SUPPORT_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactBuyer,
          },
          {
            title: FOOTER_LABELS.FAQ,
            domain: BUYER_DOMAIN_TYPE,
            externalLink: FR_BUYER_FAQ_EXTERNAL_LINK,
            linkType: FOR_BUYERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.FAQ,
          },
        ],
      },
      {
        title: FOOTER_LABELS.Sellers,
        links: [
          {
            title: FOOTER_LABELS.HelpCenter,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: FR_SELLER_HELP_CENTER,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
          {
            title: FOOTER_LABELS.StartSelling,
            domain: EXTERNAL_DOMAIN_TYPE,
            externalLink: FR_SELLER_START_SELLING,
            linkType: FOR_SELLERS_COLUMN,
            path: null,
            tooltip: null,
            tooltipPosition: null,
            trackingLabel: GaTrackingEventLabel.ContactSeller,
          },
        ],
        hideOnMMCompanion: true,
      },
    ],
    footer_for_payments: FOOTER_IMAGES[CountryCode.France],
    support_phone_number: SupportPhoneNumbers[CountryCode.France].b2c,
    support_phone_number_b2b: SupportPhoneNumbers[CountryCode.France].b2b,
    support_phone_number_subsidiary: SupportPhoneNumbers[CountryCode.France].subsidiary,
    telesales_phone_number: SupportPhoneNumbers[CountryCode.France].telesales,
    help_center_link: FR_BUYER_SUPPORT_TICKET_NEW_LINK,
    subsidiary_contact_email: SUBSIDIARY_SUPPORT_EMAIL,
    freshdesk_instance_link: FRESHDESK_INSTANCE_LINK['fr'],
  },
};
